/**
 * A component to represent a single file node
 *
 * @author Aakash Dhawan (adhawan@yext.com)
 */
import {classNames} from '/js-spruce/yext/spruce/tools/classNames2';
import {TreeActionsContainer} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/actions/TreeActionsContainer';
import {TreeNodeShape} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/shapesJsDoc';
import {SelectMode} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/SelectMode';

/**
 * @param {{
 *   node: !TreeNodeShape,
 *   selected: boolean,
 *   focused: boolean,
 *   modified: boolean,
 *   treeActionsMode: (string | undefined),
 *   treeSelectMode: string,
 *   rowRef: {current: {getBoundingClientRect: !Function}},
 *   onHoverRow: !function(string),
 *   onBulkSelect: (?function() | undefined),
 *   onClick: !function()
 * }} props
 * @return {React.ReactNode}
 */
export const FileTreeNode = React.memo(props => {
  const {
    node,
    selected,
    focused,
    onHoverRow,
    modified,
    treeActionsMode,
    treeSelectMode,
    rowRef,
    onBulkSelect,
    onClick,
  } = props;

  const [isHovered, setIsHovered] = React.useState(false);
  const handleOnHoverRow = () => {
    setIsHovered(true);
    onHoverRow(node.id);
  };

  const className = classNames({
    'tree-node__file': true,
    'tree-node--selected': selected,
    'tree-node--focused': focused,
    'tree-node__dependency': node.id === 'dependencies.json',
    'tree-node__error': node.hasError,
    'tree-node__hovered': isHovered,
    'tree-node--modified': modified,
  });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      key={node.id}
      className={className}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      onMouseOver={handleOnHoverRow}
      onMouseLeave={() => setIsHovered(false)}
    >
      <SelectMode
        node={node}
        treeSelectMode={treeSelectMode}
        onBulkSelect={onBulkSelect}
      />
      {(isHovered && treeActionsMode)
      && <TreeActionsContainer mode={treeActionsMode} rowRef={rowRef}/>}
    </div>
  );
});
